module.exports = __webpack_public_path__ + "img/1.701fc6ba.svg";